import { render, staticRenderFns } from "./backupDetails.vue?vue&type=template&id=0e71750a&scoped=true"
import script from "./backupDetails.vue?vue&type=script&lang=js"
export * from "./backupDetails.vue?vue&type=script&lang=js"
import style0 from "./backupDetails.vue?vue&type=style&index=0&id=0e71750a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e71750a",
  null
  
)

export default component.exports